import { InputTag } from '@arco-design/web-react'

export function parseJsonStringList(raw: string, fallback: string[] = []): string[] {
  if (!raw?.trim()) return fallback
  try {
    const parsed = JSON.parse(raw) as unknown
    return Array.isArray(parsed) ? parsed.map(String) : fallback
  } catch {
    return fallback
  }
}

interface Props {
  value: string
  onChange: (json: string) => void
  placeholder?: string
}

/** TagInput 风格编辑 JSON 字符串数组 option（如 fetch_setting.domain_list） */
export default function JsonListInput({ value, onChange, placeholder }: Props) {
  const tags = parseJsonStringList(value)

  return (
    <InputTag
      value={tags}
      onChange={(v) => onChange(JSON.stringify(v))}
      placeholder={placeholder}
      allowClear
      style={{ width: '100%' }}
    />
  )
}
